var SearchController;
(function (SearchController) {
    myonce('search-general', () => {
        const $wrapper = document.querySelector('#search-general');
        if ($wrapper) {
            const $filterBar = $wrapper.querySelector('.filter-bar');
            const $form = $wrapper.querySelector('.filter-bar form');
            const $query = $wrapper.querySelector('.search-header .input-group input');
            const $clear = $wrapper.querySelector('.search-header .head .input-group [data-clear]');
            const $resultCount = $wrapper.querySelector('.result-count');
            const $resultsClusterDummy = $wrapper.querySelector('.result-cluster.dummy');
            const $results = $wrapper.querySelector('.results');
            let storeRegistry = {};
            const index = $wrapper.querySelector('.search-index').value;
            const facetsDecode = {
                product: {
                    name: 'Prodotti',
                    cluster: '4:2',
                    border: 'border-full',
                    color: 'card-white',
                },
                store: {
                    name: 'Negozi',
                    cluster: '3:1',
                },
                news_bulletin: {
                    name: 'News & Media',
                    cluster: '1',
                },
                content_page: { name: 'Pagine', cluster: '1' },
                services: { name: 'Servizi', cluster: '1' },
                recipe: { name: 'Ricette', cluster: '3:1', color: 'white' },
                suggestion: { name: 'Consigli', cluster: '3:1', color: 'white' },
            };
            const facetsOrder = [
                '"product"',
                '"store"',
                '"news_bulletin"',
                '"content_page"',
                '"services"',
                '"recipe"',
                '"suggestion"',
            ];
            let payload = {
                query: '*',
                date: Date.now(),
                index,
                order: 'DESC',
                page: 0,
                filters: [],
                facets: [
                    {
                        id: 'type',
                        operator: 'AND',
                        limit: 20,
                    },
                ],
            };
            let clusters = {};
            function bindSearch(data) {
                $wrapper.setAttribute('data-spinner', 'mask');
                let body = {
                    coords: null,
                    storeName: null,
                };
                if ($query.value) {
                    body.storeName = $query.value;
                    search(data, body);
                }
                else {
                    getCoords()
                        .then(position => {
                        body.coords = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        };
                        search(data, body);
                    })
                        .catch((e) => {
                        search(data, body);
                    });
                }
            }
            function searchApiStores(data, body) {
                let stores;
                const config = retrieveConfig($wrapper);
                if (!data.filters.length ||
                    data.filters.filter(d => {
                        return ((d.id === 'type' && d.value === 'stores') ||
                            (Array.isArray(d.value) && d.value.includes('stores')));
                    }).length) {
                    stores = Fetch(`/api/esb/storelocator/searchStores?_format=form`, {
                        method: 'POST',
                        data: body,
                        token: { enable: true }
                    });
                }
                else {
                    stores = new Promise(resolve => {
                        resolve({ header: { result: 'OK' }, payload: { stores: [] } });
                    });
                }
                return stores;
            }
            function searchPromise(data, searchApi, stores, favouriteStores, $cardStore) {
                return Promise.all([searchApi, stores, favouriteStores]).then(([solrResults, storeResults, favouriteStores]) => {
                    const facets = solrResults.facets || {};
                    if ($cardStore) {
                        const stores = storeResults.payload.stores.map(store => {
                            const wrapper = document.createElement('div');
                            const $nextShop = $cardStore.cloneNode(true);
                            $nextShop.setAttribute('data-id', store.id);
                            $nextShop.querySelector('.shop-name').innerHTML = store.name;
                            $nextShop.querySelector('.shop-address').innerHTML = store.address;
                            $nextShop.querySelector('.shop-type').innerHTML =
                                store.flagType.value;
                            if (store.distance) {
                                $nextShop.querySelector('.shop-distance').innerHTML = `${store.distance} - ${store.city}`;
                            }
                            else {
                                $nextShop.querySelector('.shop-distance').innerHTML = `${store.city}`;
                            }
                            $nextShop.querySelector('.search-stores').href = `/punti-vendita`;
                            $nextShop.querySelector('.detail-store').href = `/spesa-e-servizi/punti-vendita/${store.id}/${store.name
                                .replace(/[^a-zA-Z0-9\s\-_]/gim, '')
                                .replace(/\s/gim, '-')}`;
                            if (store.logo) {
                                $nextShop.querySelector('.logo-img').src =
                                    store.logo;
                            }
                            if (favouriteStores &&
                                favouriteStores.filter(s => s.id === store.id).length) {
                                $nextShop
                                    .querySelector('.favourite-shop')
                                    .classList.add('is-favourite');
                            }
                            $nextShop.classList.remove('dummy');
                            wrapper.appendChild($nextShop);
                            storeRegistry[store.id] = store;
                            return {
                                id: store.id,
                                bundle: 'store',
                                render: wrapper.innerHTML,
                            };
                        });
                        if (stores.length) {
                            facets.type = facets.type || [];
                            facets.type.push({
                                filter: '"store"',
                                count: stores.length,
                            });
                        }
                        return {
                            ...solrResults,
                            results: solrResults.results.concat(stores),
                            facets,
                        };
                    }
                    return {
                        ...solrResults,
                        results: solrResults.results,
                        facets,
                    };
                });
            }
            function search(data, body) {
                const $cardStore = $wrapper.querySelector('.locator-search-card.dummy');
                const searchApi = Fetch('/api/search', {
                    method: 'POST',
                    token: {
                        enable: true,
                    },
                    data,
                });
                const favouriteStores = localforage.getItem('favourite_store');
                let allStores;
                allStores = body && body.coords ? searchApiStores(data, body) : new Promise(resolve => {
                    resolve({ header: { result: 'OK' }, payload: { stores: [] } });
                });
                searchPromise(data, searchApi, allStores, favouriteStores, $cardStore)
                    .then(results => {
                    print(results);
                    bindActions();
                })
                    .catch(e => {
                    console.log(e);
                    $wrapper.removeAttribute('data-spinner');
                });
            }
            function executeSearch() {
                payload = updatePayload(payload);
                bindSearch(payload);
            }
            function getOsbImage() {
                const $targets = document.querySelectorAll('img');
                $targets.forEach(($target) => {
                    const imageId = $target.getAttribute('src');
                    if (imageId.indexOf('/') === -1) {
                        Fetch('/api/getImage/' + imageId, { method: 'GET', token: { enable: true } })
                            .then(body => {
                            $target.setAttribute('src', body["data"]);
                        });
                    }
                });
            }
            function retrieveConfig($wrapper) {
                let data = {
                    url: '',
                    config: {},
                };
                const $form = $wrapper && $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        data = {
                            url: url.replace(/\/$/, ''),
                            config: JSON.parse(config),
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                return data;
            }
            function updatePayload(payload) {
                return {
                    ...payload,
                    query: ignoreCase($query.value) || '*',
                    filters: gatherFilters(),
                };
            }
            function ignoreCase(str) {
                if (str) {
                    let originalString = str.split(' ');
                    let ignoreCaseString = [];
                    originalString.forEach((word) => {
                        let lowCase, upCase;
                        lowCase = word.charAt(0).toLowerCase() + word.slice(1);
                        upCase = word.charAt(0).toUpperCase() + word.slice(1);
                        ignoreCaseString.push(lowCase);
                        ignoreCaseString.push(upCase);
                    });
                    str = ignoreCaseString.join(' ');
                }
                return str;
            }
            function gatherFilters() {
                let filters = [];
                const data = new FormData(document.querySelector('form'));
                const wornKeys = {};
                for (let key of data.keys()) {
                    let operator = '';
                    let value;
                    if (!(key in wornKeys)) {
                        wornKeys[key] = true;
                        value = data.getAll(key);
                        value = value.reduce((acc, curr) => {
                            acc = acc.concat(curr.split(';'));
                            return acc;
                        }, []);
                        if (value.length > 1) {
                            if (value.includes('!')) {
                                operator = 'NOT IN';
                                value.splice(value.indexOf('!'), 1);
                            }
                            else {
                                operator = 'IN';
                            }
                        }
                        else {
                            operator = 'EXACT';
                            value = value.pop();
                        }
                        filters.push({
                            id: key,
                            type: operator,
                            value,
                        });
                    }
                }
                return filters;
            }
            function decodeResultPreviewSize(clusterSize) {
                let deskCluster = clusterSize.split(':')[0];
                return Math.max(deskCluster, 2);
            }
            function print(resultsWrapper) {
                clusters = {};
                $results.innerHTML = '';
                let resultCountText = '<b>' +
                    resultsWrapper.results.length +
                    '</b> ' +
                    (resultsWrapper.count === 1 ? 'risultato trovato' : 'risultati trovati');
                $resultCount.innerHTML = resultCountText;
                resultsWrapper.results.forEach(result => {
                    clusters[result.bundle] = (clusters[result.bundle] || []).concat([result]);
                });
                if (resultsWrapper.facets && resultsWrapper.facets.type) {
                    let orderedFacets = [];
                    facetsOrder.forEach(facet => {
                        resultsWrapper.facets.type.find(type => {
                            if (type.filter === facet) {
                                orderedFacets.push(type);
                            }
                        });
                    });
                    orderedFacets.forEach(currentFacet => {
                        currentFacet.filter = currentFacet.filter.split('"').join('');
                        const clusterElement = $resultsClusterDummy.cloneNode(true);
                        const resultBox = clusterElement.querySelector('.results-box');
                        const title = clusterElement.querySelector('.title');
                        const buttonWrapper = clusterElement.querySelector('.button-wrapper');
                        const button = clusterElement.querySelector('.btn');
                        clusterElement.classList.remove('dummy');
                        clusterElement.id = currentFacet.filter;
                        title.innerHTML = facetsDecode[currentFacet.filter].name;
                        let cluserSizes = (facetsDecode[currentFacet.filter].cluster || '1').split(':');
                        let removeItemView = 0, hiddenElements = [];
                        let currCluster = clusters[currentFacet.filter];
                        if (currCluster) {
                            hiddenElements = currCluster && currCluster.slice(0, decodeResultPreviewSize(facetsDecode[currentFacet.filter].cluster || 1));
                            removeItemView =
                                clusters[currentFacet.filter].length - hiddenElements.length;
                            button.innerHTML = 'Mostra altri (' + removeItemView + ')';
                            if (removeItemView < 1) {
                                buttonWrapper.classList.add('hidden');
                            }
                            else {
                                button.addEventListener('click', () => {
                                    printClusterResults(resultBox, currentFacet.filter, true);
                                    buttonWrapper.classList.add('hidden');
                                    bindActions();
                                    getOsbImage();
                                });
                            }
                            if (cluserSizes.length > 1) {
                                resultBox.setAttribute('data-row-size', cluserSizes[0]);
                                resultBox.classList.add('col-num-' + cluserSizes[0]);
                                resultBox.classList.add('col-num-' + cluserSizes[1] + '-xs');
                            }
                            else {
                                resultBox.setAttribute('data-row-size', cluserSizes[0]);
                                resultBox.classList.add('col-num-' + cluserSizes[0]);
                                resultBox.classList.add('col-num-' + cluserSizes[0] + '-xs');
                            }
                            printClusterResults(resultBox, currentFacet.filter);
                            $results.appendChild(clusterElement);
                        }
                    });
                }
                $wrapper.removeAttribute('data-spinner');
            }
            function bindActions() {
                const $stores = $wrapper.querySelectorAll('.locator-search-card:not(.dummy)');
                $stores.forEach($store => {
                    const $hearth = $store.querySelector('.favourite-shop');
                    if ($hearth) {
                        $hearth.addEventListener('click', () => {
                            const id = $store.getAttribute('data-id');
                            if ($hearth.classList.contains('is-favourite')) {
                                removeFavouriteStore(storeRegistry[id]);
                            }
                            else {
                                addFavouriteStore(storeRegistry[id]);
                            }
                            $hearth.classList.toggle('is-favourite');
                        });
                    }
                });
            }
            function addFavouriteStore(store) {
                localforage.getItem('favourite_store').then(stores => {
                    stores = stores || [];
                    stores.push(store);
                    localforage.setItem('favourite_store', stores);
                });
            }
            function removeFavouriteStore(store) {
                localforage.getItem('favourite_store').then(stores => {
                    stores = stores || [];
                    localforage.setItem('favourite_store', stores.filter(s => store.id !== s.id));
                });
            }
            function printClusterResults(resultBox, facetName, showAll = false) {
                let currCluster = clusters[facetName] || [];
                resultBox.innerHTML = '';
                let resultsToShow = showAll
                    ? currCluster
                    : currCluster.slice(0, decodeResultPreviewSize(facetsDecode[facetName].cluster || 1));
                resultsToShow.forEach(result => {
                    let resultDiv = document.createElement('div');
                    resultDiv.classList.add('result-wrapper', 'card-item', facetsDecode[facetName].border, facetsDecode[facetName].color);
                    resultDiv.innerHTML = result.render;
                    resultBox.appendChild(resultDiv);
                });
            }
            function initUI() {
                const selects = $filterBar.querySelectorAll('select');
                if (selects.length) {
                    let selectCollection = tail.select(selects, {
                        hideSelected: false,
                        hideDisabled: true,
                        multiShowCount: false,
                        multiSelectAll: false,
                    });
                    let selectList = Array.isArray(selectCollection)
                        ? selectCollection
                        : [selectCollection];
                    selectList.forEach(select => {
                        select.on('open', () => {
                            $filterBar.classList.add('showOverflowY');
                        });
                        select.on('close', () => {
                            $filterBar.classList.remove('showOverflowY');
                        });
                        select.on('change', () => {
                            executeSearch();
                        });
                    });
                }
                $form.addEventListener('submit', e => {
                    e.preventDefault();
                    executeSearch();
                });
                const $filters = $form.querySelectorAll('input');
                $filters.forEach(inputFilter => {
                    inputFilter.addEventListener('click', () => {
                        executeSearch();
                    });
                });
                $query.addEventListener('keypress', e => {
                    $query.parentElement.classList.toggle('is-filled', !!$query.value);
                    if (e.key === 'Enter') {
                        executeSearch();
                    }
                });
                $clear.addEventListener('click', () => {
                    $query.value = '';
                    trigger($query, 'keypress');
                    history.pushState({}, '', location.href.replace(location.search, ''));
                    executeSearch();
                });
            }
            function init() {
                const queryParams = new URLSearchParams(location.search);
                initUI();
                if (queryParams.get('query')) {
                    $query.value = queryParams.get('query');
                    trigger($query, 'keypress');
                }
                executeSearch();
            }
            init();
        }
    });
})(SearchController || (SearchController = {}));
